import "core-js/modules/es.object.define-property";
import { __decorate, __extends } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import store from '@/store/index';

var WechatPopup =
/** @class */
function (_super) {
  __extends(WechatPopup, _super);

  function WechatPopup() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    return _this;
  }

  Object.defineProperty(WechatPopup.prototype, "storeVisible", {
    get: function get() {
      return store.state.util.wechatPopupVisible;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(WechatPopup.prototype, "activityId", {
    get: function get() {
      return this.$route.params.activityId || store.getters['activity/activityId'];
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(WechatPopup.prototype, "activityBasicInfo", {
    // 赛事基础信息
    get: function get() {
      return store.state.activity.basicInfo[this.activityId];
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(WechatPopup.prototype, "enterCode", {
    get: function get() {
      var _a;

      return (_a = this.activityBasicInfo) === null || _a === void 0 ? void 0 : _a.enterprise_code;
    },
    enumerable: false,
    configurable: true
  });

  WechatPopup.prototype.watchstoreVisible = function () {
    this.visible = this.storeVisible;
  };

  WechatPopup.prototype.close = function () {
    this.visible = false;
    store.commit('setWechatPopupVisible', false);
  };

  __decorate([Watch('storeVisible')], WechatPopup.prototype, "watchstoreVisible", null);

  WechatPopup = __decorate([Component({
    name: 'WechatPopup'
  })], WechatPopup);
  return WechatPopup;
}(Vue);

export default WechatPopup;